import React from 'react';
import { IconButton, Link } from '@chakra-ui/react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppButton = () => {
  const phone = '601170180057'; 
  const text = encodeURIComponent('Hi there! I’d like to learn more about your services.');
  const href = `https://api.whatsapp.com/send?phone=${phone}&text=${text}`;

  return (
    <Link
      href={href}
      isExternal
      _hover={{ textDecoration: 'none' }}
      style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 9999 }}
    >
      <IconButton
        aria-label="Chat on WhatsApp"
        icon={<FaWhatsapp size="48px" />}
        borderRadius="full"
        boxShadow="lg"
        bg="#25D366"            
        color="white"          
        _hover={{ bg: '#20b958' }}
        _active={{ bg: '#1ebe57' }}
        size="lg"              
      />
    </Link>
  );
};

export default WhatsAppButton;
